import iotsafeRequest from "./iotsafe-request";

export type VpnServerState = "pending" | "running" | "stopping" | "stopped" | "shutting-down" | "terminated" | "not_created";

export interface VpnServerInfo {
  index: number;
  instanceId: string | null;
  state: VpnServerState;
  publicIp: string | null;
  privateIp: string | null;
}

export interface VpnServersResponse {
  servers: VpnServerInfo[];
}

export interface VpnConnectedClient {
  commonName: string;
  realAddress: string;
  virtualAddress: string;
  bytesSent: number;
  bytesReceived: number;
  connectedSince: string;
}

export interface VpnServerConnectionsResponse {
  data: VpnConnectedClient[];
  pageIndex: number;
  totalItems: number;
  totalPages: number;
}

export interface GetVpnServerConnectionsQuery {
  keyword?: string;
  commonName?: string;
  realAddress?: string;
  virtualAddress?: string;
  connectedSinceFrom?: string;
  connectedSinceTo?: string;
  timezoneOffset?: number;
  pageIndex?: number;
  pageSize?: number;
  sortType?: "ASC" | "DESC";
  sortBy?: string;
}

export const getVpnServers = () => {
  return iotsafeRequest.get<any, VpnServersResponse>("/v1/vpn/servers");
};

export const getVpnServerCount = () => {
  return iotsafeRequest.get<any, { count: number }>("/v1/vpn/servers/count");
};

export const updateVpnServerCount = (count: number) => {
  return iotsafeRequest.put("/v1/vpn/servers/count", { count });
};

export const startVpnServer = (index: number) => {
  return iotsafeRequest.post(`/v1/vpn/servers/${index}/start`);
};

export const stopVpnServer = (index: number) => {
  return iotsafeRequest.post(`/v1/vpn/servers/${index}/stop`);
};

export const getVpnServerConnections = (index: number, params: GetVpnServerConnectionsQuery) => {
  return iotsafeRequest.get<any, VpnServerConnectionsResponse>(`/v1/vpn/servers/${index}/connections`, { params });
};
